import { render, staticRenderFns } from "./ProductInfoBase.vue?vue&type=template&id=462781f8&scoped=true&"
import script from "./ProductInfoBase.vue?vue&type=script&lang=js&"
export * from "./ProductInfoBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462781f8",
  null
  
)

export default component.exports